import {
  ApiBlueprint,
  configApiRef,
  createApiFactory,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { OAuth2 } from '@backstage/core-app-api';
import {
  BackstageIdentityApi,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';

/**
 * Custom OIDC auth API ref for the Keycloak realm Portal.
 *
 * Backstage's @backstage/core-plugin-api does not export an oidcAuthApiRef
 * out of the box — only google/github/microsoft/okta/etc. For a generic OIDC
 * provider we declare our own apiRef and wire it to OAuth2.create() pointing
 * at the backend's /api/auth/oidc endpoints (provider id `oidc` matches
 * app-config.production.yaml > auth.providers.oidc).
 */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({
  id: 'auth.oidc',
});

const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
          OAuth2.create({
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: 'oidc',
              title: 'Keycloak Portal',
              icon: () => null,
            },
            environment:
              configApi.getOptionalString('auth.environment') ?? 'production',
            defaultScopes: ['openid', 'profile', 'email'],
          }),
      }),
    ),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'oidc-provider',
            title: 'Keycloak Portal',
            message: 'Entrar com sua conta corporativa Linuxell',
            apiRef: oidcAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi, signInPage],
});
